import { setSessionStorageItem } from '../../../../commons/utils';
import { SESSION_STORAGE_PRICE_BOOKING } from '../../../../commons/constants';

export default (currentPriceVar) => {
  return (newPrice) => {
    currentPriceVar(newPrice);
    setSessionStorageItem(SESSION_STORAGE_PRICE_BOOKING, newPrice);
  };
};
